console.log("image-navigation.js loaded");

// Import Swiper and modules
import Swiper from "swiper";
import { Zoom, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/zoom";
import "swiper/css/navigation";
import "swiper/css/pagination";

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".image-navigation").forEach((gallery) => {
        const swiperElement = gallery.querySelector(".swiper");
        const prevBtn = gallery.querySelector(".swiper-button-prev");
        const nextBtn = gallery.querySelector(".swiper-button-next");
        const slidesCount = gallery.querySelectorAll(".swiper-slide").length;

        const slidesPerView = 1;
        const loop = slidesCount > slidesPerView;

        if (!loop) {
            prevBtn?.remove();
            nextBtn?.remove();
        }

        new Swiper(swiperElement, {
            modules: [Zoom, Navigation, Pagination],
            direction: "horizontal",
            loop: false,
            zoom: true,
            slidesPerView: slidesPerView,

            slidesPerGroup: slidesPerView,
            watchOverflow: true,
            spaceBetween: 10,
            centerInsufficientSlides: true,

            navigation: {
                nextEl: nextBtn,
                prevEl: prevBtn,
            },
            pagination: {
                el: gallery.querySelector(".swiper-pagination"),
                clickable: true,
            },
            breakpoints: {
                0: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                },
                460: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                },
                540: {
                    slidesPerView: 5,
                    slidesPerGroup: 5,
                },
                650: {
                    slidesPerView: 6,
                    slidesPerGroup: 6,
                },
                720: {
                    slidesPerView: 7,
                    slidesPerGroup: 7,
                    spaceBetween: 16,
                },
                920: {
                    slidesPerView: 8,
                    slidesPerGroup: 8,
                    spaceBetween: 16,
                },
                1040: {
                    slidesPerView: 10,
                    slidesPerGroup: 10,
                    spaceBetween: 16,
                },
            },
        });
    });
});
